(function() {
	'use strict';

	angular
		.module('app.setup')
		.controller('projectTemplates', projectTemplates);

	projectTemplates.$inject = ['$rootScope', '$scope', '$filter', '$timeout', '$compile', '$uibModal', 'projectTemplatesService', 'editProjectService', 'storeService', '$q'];

	function projectTemplates($rootScope, $scope, $filter, $timeout, $compile, $uibModal, projectTemplatesService, editProjectService, storeService, $q) {
		var vm = this;
		var adminConfig = storeService.getState().adminConfig;
		vm.leanDirFactoryNdx = adminConfig.factory.id;
		vm.dropdownLists = {};
		vm.projectTemplates = [];
		vm.addTemplate = addTemplate;
		vm.openTemplateTasks = openTemplateTasks;
		vm.deleteTemplate = deleteTemplate;
		vm.startEdit = startEdit;
		vm.cancelEdit = cancelEdit;
		vm.categoriesTagTransform = categoriesTagTransform;

		activate();

		function activate() {
			getProjectTemplates();
		}

		function getProjectTemplates() {
			var templatesPromiseList = [
				projectTemplatesService.getProjectTemplates(vm.leanDirFactoryNdx),
				projectTemplatesService.getProjectTemplateDefault(vm.leanDirFactoryNdx)
			];
			$q.all(templatesPromiseList).then(function (result) {
				var projectTemplates = result[0];
				var projectTemplateDefault = result[1];

				if (projectTemplates.data && projectTemplates.data.length) {
					vm.projectTemplates = projectTemplates.data;
				} else {
					// Assign a empty list, so that frontend will show empty grid
					vm.projectTemplates = [];
				}
				if (projectTemplateDefault.data && vm.projectTemplates.length) {
					var defaultTemplate = vm.projectTemplates.find(function (template) {
						return template.ndx === projectTemplateDefault.data.templateNdx;
					});
					if (defaultTemplate) {
						defaultTemplate.default = true;
					}
				}
			});
		}
		
		function openTemplateTasks(ndx) {
			window.location = '/application/f/home.html#/setup/project-templates/tasks?templateNdx=' + ndx;
		}
		
		function addTemplate() {
			var addTemplateFormScope = $scope.$new();
			var opts = {
				scope: addTemplateFormScope,
				templateUrl: '/application/f/setup/projects/templates/add-template.html',
				size: 'sm',
				backdrop: 'static'
			};

			var instance = $uibModal.open(opts);
			addTemplateFormScope.closeDialog = function() {
				instance.close();
				addTemplateFormScope.$destroy();
			};

			addTemplateFormScope.result = function(message, isSuccessful) {
				$rootScope.$emit('toast', {'message': message, 'success': isSuccessful});
				if (isSuccessful) {
					getProjectTemplates();
				}
				if (isSuccessful || message === '') {
					instance.close();
					addTemplateFormScope.$destroy();
				}
			};
		}
		
		function loadList(type) {
			if (vm.dropdownLists[type] && vm.dropdownLists[type].length && type !== 'projectArea' && type !== 'categories') {
				return;
			} else {
				switch (type) {
				case 'projectArea':
					editProjectService.getAreas(vm.leanDirFactoryNdx, true).then(function (areas) {
						if (!areas || !areas.length) {
							areas = [];
						}
						for (var i = 0; i < areas.length; i++) {
							areas[i].projectArea = strip(areas[i].projectArea);
						}
						vm.dropdownLists[type] = areas;
					});
					break;
				case 'projectTypeId':
					editProjectService.getProjectTypes(vm.leanDirFactoryNdx).then(function (projectTypes) {
						if (!projectTypes || !projectTypes.length) {
							projectTypes = [];
						}
						vm.dropdownLists[type] = projectTypes;
					});
					break;
				case 'isCrossSite':
				case 'default':
					vm.dropdownLists[type] = [{id: 1, display: 'Yes'},{id: 0, display: 'No'}];
					break;
				case 'categories':
					editProjectService.getCategories(vm.leanDirFactoryNdx).then(function (categories) {
						if (categories && categories.length) {
							categories = categories.map(function (category) {
								var transformedCategory = {};
								transformedCategory.name = category.projectCategoryName;
								transformedCategory.id = category.projectCategoryId;
								transformedCategory.status = category.status;
								return transformedCategory;
							});
						} else {
							categories = [];
						}
						vm.dropdownLists[type] = categories;
						if (callback) {
							callback();
						}
					});
					break;
				}
			}
		}
		
		function getTemplate(position, rowIndex, fieldInputType, fieldName) {
			var windowWidth = window.innerWidth;
			var windowHeight = window.innerHeight;
			var conatinerWidth = '';
			var divHeight = 112;
			var extraClass = 'textEdit';
			if (fieldInputType === 'textArea') {
				divHeight = 348;
				extraClass = ' textAreaEdit description-area';
			}
			
			if (position.left + 296 > windowWidth) {
				position.left = position.left - (position.left + 296 - windowWidth - 8);
			}
			if (position.top + divHeight > windowHeight) {
				position.top = position.top - (position.top + divHeight - windowHeight - 8);
			}
			
			if (fieldInputType === 'textArea') {
				if (position.left + 840 > windowWidth) {
					conatinerWidth = windowWidth - position.left - 50;
					conatinerWidth = 'width:' + conatinerWidth + 'px;';
				}
			}
			
			var header = 'Edit ' + fieldName;
			var scopeModal = 'tableCtrl.editFieldValue';
			
			var editTemplate = '<div class="inlineEditDiv ' + extraClass + '" style="top:' + position.top + 'px; left: ' +
				position.left + 'px;' + conatinerWidth + '"><div class="inlineEditHeader">' + header + '</div>' +
				'<span id="errorMsg" style="color:red;" class="hide"></span>' +
				(fieldInputType === 'textArea' ? '<textarea class="inlineEditInput" ng-model="' + scopeModal + '"></textarea>' : '<input class="inlineEditInput" ng-model="' + scopeModal + '" />') +
				'<div class="inlineEditButtons"><a class="button flat" ng-click="tableCtrl.cancelEdit()">Cancel</a>' +
				'<a class="button flat colored" ' +
				'ng-click="(' + scopeModal + ' && ' + scopeModal + '.length>0) && ' + 'tableCtrl.saveEdit(' + rowIndex + ', \'' +  fieldName + '\')">Save</a></div></div>';
			return editTemplate;
		}
		
		function getListTemplate(position, index, fieldId, label, id, display, dropDownType) {
			var windowWidth = window.innerWidth;
			var windowHeight = window.innerHeight;
			if (position.left + 340 > windowWidth) {
				position.left = position.left - (position.left + 340 - windowWidth - 8);
			}
			if (position.top + 356 > windowHeight) {
				position.top = position.top - (position.top + 356 + 112 - windowHeight);
			}

			var editTemplate = '<div ng-click="$event.preventDefault();" class="inlineEditDiv textEdit" style="top:' + position.top + 'px; left: ' + position.left + 'px;">' +
				'<div class="inlineEditHeader">Choose ' + label + '</div>' +
				'<ui-select append-to-body="false" theme="bootstrap" ng-model="tableCtrl.editFieldValue">' +
				'<ui-select-match placeholder="{{\'Select ' + label + '...\'' + ' | translate}}">' +
				'{{$select.selected.' + display + '}}' +
				'</ui-select-match>' +
				'<ui-select-choices ui-disable-choice="item.status === \'Archive\'" repeat="item.' + id + ' as item in tableCtrl.dropdownLists.' + dropDownType + ' | filter: $select.search">' +
				'<div>{{item.' + display + '}}</div>' +
				'</ui-select-choices>' +
				'</ui-select>' +
				'<div class="inlineEditButtons">' +
				'<button class="button flat" ng-click="tableCtrl.cancelEdit()">Cancel</button>' +
				'<button class="button flat colored" ng-click="tableCtrl.saveEdit(' + index + ', \'' +  fieldId + '\', \'' +  dropDownType + '\', \'' +  label + '\')">Save</button>' +
				'</div>' +
				'</div>';
			return editTemplate;
		}
		
		function startEdit($template, fieldName, index, fieldType, fieldLabel, id, display, dropDownType) {
			if (jQuery('.inlineEditDiv').length) {
				jQuery('.inlineEditDiv').unbind();
				jQuery('.inlineEditDiv').remove();
			}
			var cell = jQuery('#' + fieldName + index);
			var pos = cell.offset();

			var rowIndex = vm.projectTemplates.indexOf($template);
			var content = vm.projectTemplates[rowIndex][fieldName];
			if (fieldName === 'isCrossSite' || fieldName === 'default') {
				content = vm.projectTemplates[rowIndex][fieldName] ? 1 : 0;
			}
			var editTemplate;
			if (fieldType === 'list') {
				editTemplate = getListTemplate(pos, rowIndex, fieldName, fieldLabel, id, display, dropDownType);
			} else if (fieldType === 'tags') {
				editTemplate = getTagListTemplate(pos, rowIndex, fieldName, fieldLabel, id, display, true);
			} else {
				editTemplate = getTemplate(pos, rowIndex, fieldType, fieldName);
			}
			
			if (fieldType === 'list' || fieldType === 'tags') {
				loadList(dropDownType);			
			}

			var compiledDiv = $compile(editTemplate)($scope);
			vm.editFieldValue = content;
			jQuery('#projectTemplates').append(compiledDiv);
			compiledDiv.keyup(function(event) {
				var code = event.keyCode || event.which;
				if (code === 13) {
					if (fieldType === 'list') {
						vm.saveEdit(rowIndex, fieldName, dropDownType, fieldLabel);
					} else if (fieldType !== 'tags') {
						if (vm.editFieldValue == null || strip(vm.editFieldValue) === '') {
							return;
						}
						vm.saveEdit(rowIndex, fieldName);
					}
				} else if (code === 27) {
					vm.cancelEdit();
				}
			});
			
			jQuery('.inlineEditDiv input').focus();
			vm.inlineActive = true;
		};

		
		function cancelEdit() {
			jQuery('.inlineEditDiv').unbind();
			jQuery('.inlineEditDiv').remove();
			vm.inlineActive = false;

			if ($scope.$$childTail.$selectMultiple) {
				// destroy multiselects if exists
				delete $scope.$$childTail.$select;
				delete $scope.$$childTail.$selectMultiple;
			}
		}

		vm.saveEdit = function(index, fieldName, saveFieldName, label) {
			var content = strip(vm.editFieldValue);
			var saveObj = {};
			saveObj.ndx = vm.projectTemplates[index].ndx;
			var tempField = vm.projectTemplates[index][fieldName];
			if (fieldName === 'isCrossSite' || fieldName === 'default') {
				content = content === '1';
			}
			var changeMade = tempField !== content;
			if (fieldName === 'categories') {
				saveObj.categoryIds = [];
				saveObj.newCategories = [];
				angular.forEach(vm.editFieldValue, function (categoryId) {
					if (('' + categoryId).indexOf('tag-') !== 0) {
						saveObj.categoryIds.push(categoryId);
					} else {
						saveObj.newCategories.push(categoryId.substring(4));
					}
				});
				if (tempField && tempField.length) {
					var categoryIds = tempField.map(function(category) {
						return category.id;
					});
					changeMade = !_.isEqual(vm.editFieldValue.sort(), categoryIds.sort());
				}
			} else {
				saveObj[saveFieldName ? saveFieldName : fieldName] = content;
			}

			if (changeMade) {
				if (fieldName === 'default') {
					projectTemplatesService.saveProjectTemplateDefault(saveObj.ndx, vm.leanDirFactoryNdx)
						.then(function (response) {
							if (response && response.status && response.status >= 200 && response.status < 400) {
								$rootScope.$emit('toast', {'message': 'Template ' + (label ? label.toLowerCase() : fieldName) + ' was saved successfully', 'success': true});
								getProjectTemplates();
							} else {
								$rootScope.$emit('toast', {'message': 'Unexpected server error', 'success': false});
							}
						});
				} else {
					projectTemplatesService.updateTemplateField(saveObj, (new Date(vm.projectTemplates[index].lastModified)).toUTCString(), vm.leanDirFactoryNdx)
						.then(function(response) {
							if (response && response.status && response.status >= 200 && response.status < 400) {
								$rootScope.$emit('toast', {'message': 'Template ' + (label ? label.toLowerCase() : fieldName) + ' was saved successfully', 'success': true});
								getProjectTemplates();
							} else if (response && response.status === 412) {
								var errorMessage = 'This template field has been updated since you last loaded the page, please refresh the page';
								if (response && response.data && response.data.error) {
									errorMessage = response.data.error;
								}
								$rootScope.$emit('toast', {'message': errorMessage, 'success': false});
							} else {
								$rootScope.$emit('toast', {'message': 'Unexpected server error', 'success': false});
							}
						});
				}
			}
			jQuery('.inlineEditDiv').unbind();
			jQuery('.inlineEditDiv').remove();
			vm.inlineActive = false;
			vm.cancelEdit();
		};
		
		function deleteTemplate(templateNdx) {
			var confirmScope = $scope.$new();
			confirmScope.templateNdx = templateNdx;
			confirmScope.additionalText = 'delete this project template';
			confirmScope.buttonText = 'Delete';
			var opts = {
				scope: confirmScope,
				templateUrl: '/application/f/core/confirm.html'
			};

			var instance = $uibModal.open(opts);
			confirmScope.closeDialog = function() {
				instance.close();
				confirmScope.$destroy();
			};

			confirmScope.yes = function() {
				var templateNdx = confirmScope.templateNdx;
				instance.close();
				confirmScope.$destroy();
				projectTemplatesService.deleteTemplate(templateNdx, vm.leanDirFactoryNdx).then(function(message) {
					var isSuccessful = (message == 'Project template deleted successfully');
					$rootScope.$emit('toast', {'message': message, 'success': isSuccessful});
					if (isSuccessful) {
						getProjectTemplates();
					}
				});
			};
		}

		function categoriesTagTransform(newTag) {
			return {
				name: newTag,
				id: 'tag-' + newTag
			};
		}

		function getTagListTemplate(position, index, fieldId, label, id, display, multiSelect) {
			var windowWidth = window.innerWidth;
			var windowHeight = window.innerHeight;
			if (position.left + 340 > windowWidth) {
				position.left = position.left - (position.left + 340 - windowWidth - 8);
			}
			if (position.top + 356 > windowHeight) {
				position.top = position.top - (position.top + 356 - windowHeight - 8);
			}

			var multiSelectStr = (multiSelect ? 'multiple' : '');
			var uiSelectMatchTerm = (multiSelect ? '<span ng-bind-html="$item.name + ($item.status === \'Archive\' ? \' (archived)\': \'\')"></span>' : '<span ng-bind-html="$select.selected.' + display + '"></span>"');
			var className = multiSelect ? 'multiselect-edit' : 'textEdit';

			var editTemplate = '<div ng-click="$event.preventDefault();" class="inlineEditDiv ' + className + '" style="top:' + position.top + 'px; left: ' + position.left + 'px;">' +
				'<div class="inlineEditHeader">Choose ' + label + '</div>' +
				'<ui-select ' + multiSelectStr + ' tagging="tableCtrl.' + fieldId + 'TagTransform" append-to-body="true" theme="bootstrap" ng-model="tableCtrl.editFieldValue">' +
				'<ui-select-match placeholder="{{\'Select ' + label + '...\'' + ' | translate}}">' +
				uiSelectMatchTerm +
				'</ui-select-match>';

			editTemplate += '<ui-select-choices ui-disable-choice="item.status === \'Archive\'" repeat="item.' + id + ' as item  in tableCtrl.dropdownLists.' + fieldId + ' | filter: $select.search">' +
				'<div ng-if="item.isTag"><span ng-bind-html="item.' + display + '"></span><span translate>(Click or press Enter to create)</span></div>' +
				'<div ng-if="!item.isTag"><span ng-bind-html="item.' + display + '"></span></div>' +
				'</ui-select-choices>' +
				'</ui-select>';
			editTemplate += '<div class="inlineEditButtons">' +
				'<button class="button flat" ng-click="tableCtrl.cancelEdit()">Cancel</button>' +
				'<button class="button flat colored" ng-click="tableCtrl.saveEdit(\'' + index + '\', \'' + fieldId + '\', \'' + fieldId + '\', \'' + label + '\')">Save</button>' +
				'</div>' +
				'</div>';
			return editTemplate;
		}
	}
})();
